import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { useQuery } from '@apollo/client';
import {
	RESUME_PENDING_PAYMENT_TITLE,
	RESUME_PENDING_PAYMENT_DESCRIPTION,
	RESUME_PENDING_PAYMENT_BUTTON,
} from '../../../../constants/Copy';
import { ROUTE_LOGIN } from '../../../../constants/Routes';
import { hasValidVideolandCookie } from '../../../../helpers/authentication';
import Heading, { HEADING_SIZE } from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import { stateRender } from '../../../../helpers/react';
import { getAccountClient } from '../../../../api/accountService';
import queryPurchaseStatus from '../../../../graphql/queryPurchaseStatus.graphql';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_FUNNEL,
	EVT_PAYMENT_RETRY,
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_TYPE_BUTTON,
} from '../../../../constants/SnowplowEvents';

const videolandAccountApiClient = getAccountClient();

const ResumePendingPayment = () => {
	const isLoggedIn = hasValidVideolandCookie();
	const [pendingPaymentUrl, setPendingPaymentUrl] = useState(null);

	const { loading, data, error } = useQuery(queryPurchaseStatus, {
		client: videolandAccountApiClient,
		fetchPolicy: 'no-cache',
		skip: !isLoggedIn,
	});

	useEffect(() => {
		if (!loading && data) {
			const purchaseState = data.me.purchaseState;

			if (!purchaseState.pendingPaymentUrl) {
				window.location.href = purchaseState.returnUrl;
			}

			setPendingPaymentUrl(purchaseState.pendingPaymentUrl);
		}
	}, [loading, data, error]);

	if (!isLoggedIn) {
		return <Redirect to={ROUTE_LOGIN} />;
	}

	return stateRender({
		isPending: loading || !pendingPaymentUrl,
		isError: error,
		onSuccess: () => (
			<>
				<Heading
					size={HEADING_SIZE.LARGE}
					className="full-page-message__heading"
					testId="full-page-message-title"
				>
					{RESUME_PENDING_PAYMENT_TITLE}
				</Heading>
				<div className="onboarding__text" data-test="full-page-message-description">
					<p>{RESUME_PENDING_PAYMENT_DESCRIPTION}</p>
				</div>
				<Button
					href={pendingPaymentUrl}
					onClick={async () => {
						await initiateTrackStructEvent({
							category: EVT_FUNNEL,
							action: EVT_PAYMENT_RETRY,

							rtlElementContext: {
								elementInteraction: EVT_ELEMENT_INTERACTION,
								elementGroup: EVT_PAYMENT_RETRY,
								elementType: EVT_ELEMENT_TYPE_BUTTON,
								elementName: EVT_PAYMENT_RETRY,
								elementLabel: RESUME_PENDING_PAYMENT_BUTTON,
							},
						});
					}}
				>
					{RESUME_PENDING_PAYMENT_BUTTON}
				</Button>
			</>
		),
	});
};

export default ResumePendingPayment;
